/* import __COLOCATED_TEMPLATE__ from './paywall-component.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { notImplemented } from '@intercom/pulse/lib/computed-properties';

export default Component.extend({
  attributeBindings: ['data-test-paywall'],
  ['data-test-paywall']: true,
  classNames: [
    'paywall__container',
    'flex-auto',
    'flex',
    'flex-row',
    'items-center',
    'justify-start',
  ],
  hideTier: false,
  callToAction: notImplemented('common/paywall-component: You must pass a callToAction label'),
});
